import { Component, Input, NgModule, NgZone, ViewChild, EventEmitter, HostBinding, Output, ElementRef, ContentChildren, Directive, InjectionToken, Inject, ViewContainerRef, TemplateRef, ɵɵdefineInjectable, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { FlexLayoutModule } from '@angular/flex-layout';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject } from 'rxjs';
import { throttleTime, map, pairwise, distinctUntilChanged, share, takeUntil, debounceTime } from 'rxjs/operators';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { maskInput } from 'vanilla-text-mask/dist/vanillaTextMask.js';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/material/list';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/flex-layout/extended';
import * as ɵngcc5 from '@angular/flex-layout/flex';
import * as ɵngcc6 from '@angular/material/icon';
import * as ɵngcc7 from '@angular/cdk/overlay';
import * as ɵngcc8 from '@angular/forms';
import * as ɵngcc9 from '@angular/material/autocomplete';
import * as ɵngcc10 from '@angular/cdk/scrolling';
import * as ɵngcc11 from '@angular/material/button';
import * as ɵngcc12 from '@angular/material/expansion';
import * as ɵngcc13 from '@angular/material/slider';
import * as ɵngcc14 from '@angular/material/form-field';
import * as ɵngcc15 from '@angular/material/input';

function SideNavComponent_ng_container_1_a_1_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-icon", 8);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("svgIcon", item_r1 == null ? null : item_r1.icon);
} }
const _c0 = function (a0) { return [a0]; };
const _c1 = function (a0) { return { "active-fragment": a0 }; };
function SideNavComponent_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelement(3, "div", 5);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "span", 6);
    ɵngcc0.ɵɵtemplate(7, SideNavComponent_ng_container_1_a_1_mat_icon_7_Template, 1, 1, "mat-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(9, _c0, item_r1 == null ? null : item_r1.link))("fragment", item_r1 == null ? null : item_r1.fragment)("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c1, ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r3.route.fragment) === (item_r1 == null ? null : item_r1.fragment) || (item_r1 == null ? null : item_r1.fragment) === "" || !(item_r1 == null ? null : item_r1.fragment) || (item_r1 == null ? null : item_r1.fragment == null ? null : item_r1.fragment.length) > 0 && (item_r1 == null ? null : item_r1.fragment) === ctx_r3.defaultFragment && ɵngcc0.ɵɵpipeBind1(2, 7, ctx_r3.route.fragment) == null));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(item_r1 == null ? null : item_r1.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r1 == null ? null : item_r1.icon);
} }
function SideNavComponent_ng_container_1_a_2_mat_icon_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-icon", 8);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("svgIcon", item_r1 == null ? null : item_r1.icon);
} }
function SideNavComponent_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 6);
    ɵngcc0.ɵɵtemplate(4, SideNavComponent_ng_container_1_a_2_mat_icon_4_Template, 1, 1, "mat-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("href", ɵngcc0.ɵɵpureFunction1(3, _c0, item_r1 == null ? null : item_r1.externalLink), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1 == null ? null : item_r1.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r1 == null ? null : item_r1.icon);
} }
function SideNavComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SideNavComponent_ng_container_1_a_1_Template, 8, 13, "a", 2);
    ɵngcc0.ɵɵtemplate(2, SideNavComponent_ng_container_1_a_2_Template, 5, 5, "a", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (item_r1 == null ? null : item_r1.link) !== "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1 == null ? null : item_r1.externalLink);
} }
const _c2 = ["container"];
const _c3 = function (a0) { return { "position": a0 }; };
const _c4 = function (a0, a1) { return { "height": a0, "display": a1 }; };
const _c5 = ["*"];
function SearchBarComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 4);
    ɵngcc0.ɵɵlistener("focus", function SearchBarComponent_div_0_ng_container_2_Template_input_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); ctx_r3.active.emit(true); return ctx_r3.isActive = true; })("focusout", function SearchBarComponent_div_0_ng_container_2_Template_input_focusout_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); ctx_r5.active.emit(false); return ctx_r5.isActive = false; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r1.placeholder)("formControl", ctx_r1.control);
    ɵngcc0.ɵɵattribute("id", ctx_r1.id)("aria-label", ctx_r1.placeholder);
} }
function SearchBarComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 5);
    ɵngcc0.ɵɵlistener("focus", function SearchBarComponent_div_0_ng_container_3_Template_input_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); ctx_r7.active.emit(true); return ctx_r7.isActive = true; })("focusout", function SearchBarComponent_div_0_ng_container_3_Template_input_focusout_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); ctx_r9.active.emit(false); return ctx_r9.isActive = false; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "mat-autocomplete", 6, 7);
    ɵngcc0.ɵɵlistener("optionSelected", function SearchBarComponent_div_0_ng_container_3_Template_mat_autocomplete_optionSelected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.optionSelected.emit($event); });
    ɵngcc0.ɵɵprojection(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(3);
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r2.placeholder)("formControl", ctx_r2.control)("matAutocomplete", _r6);
    ɵngcc0.ɵɵattribute("id", ctx_r2.id)("aria-label", ctx_r2.placeholder);
} }
function SearchBarComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "mat-icon", 2);
    ɵngcc0.ɵɵtemplate(2, SearchBarComponent_div_0_ng_container_2_Template, 2, 4, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(3, SearchBarComponent_div_0_ng_container_3_Template, 5, 5, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.autoComplete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.autoComplete);
} }
const _c6 = ["atlasCarousel"];
function CarouselComponent_ng_container_5_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_container_5_button_3_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.slideNext(); });
    ɵngcc0.ɵɵelement(1, "mat-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("svgIcon", ctx_r4.rightIcon);
} }
function CarouselComponent_ng_container_5_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_container_5_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.slidePrev(); });
    ɵngcc0.ɵɵelement(1, "mat-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("svgIcon", ctx_r5.leftIcon);
} }
function CarouselComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5, 6);
    ɵngcc0.ɵɵtemplate(3, CarouselComponent_ng_container_5_button_3_Template, 2, 1, "button", 7);
    ɵngcc0.ɵɵtemplate(4, CarouselComponent_ng_container_5_button_4_Template, 2, 1, "button", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isEnd());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isBeginning());
} }
const _c7 = function (a0) { return { "show-arrows": a0 }; };
const _c8 = [[["mat-expansion-panel"]]];
const _c9 = ["mat-expansion-panel"];
function SliderComponent_p_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.disabled === true ? "disabled-content" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.labelContent);
} }
function SliderComponent_mat_form_field_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-form-field");
    ɵngcc0.ɵɵelementStart(1, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function SliderComponent_mat_form_field_11_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.sliderValue = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.sliderValue)("min", ctx_r1.min)("max", ctx_r1.max)("disabled", ctx_r1.disabled);
} }
class SideNavComponent {
    constructor(route) {
        this.route = route;
        this.links = [];
        this.defaultFragment = '';
    }
    ngOnInit() { }
}
SideNavComponent.ɵfac = function SideNavComponent_Factory(t) { return new (t || SideNavComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ActivatedRoute)); };
SideNavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SideNavComponent, selectors: [["atlas-side-nav"]], inputs: { links: "links", defaultFragment: "defaultFragment" }, decls: 2, vars: 1, consts: [[1, "atlas-side-nav"], [4, "ngFor", "ngForOf"], ["mat-list-item", "", "routerLinkActive", "active-link", 3, "routerLink", "fragment", "ngClass", 4, "ngIf"], ["mat-list-item", "", "target", "_blank", 3, "href", 4, "ngIf"], ["mat-list-item", "", "routerLinkActive", "active-link", 3, "routerLink", "fragment", "ngClass"], [1, "selected-icon"], ["fxFlex", "1 1 auto"], ["role", "img", "aria-hidden", "true", 3, "svgIcon", 4, "ngIf"], ["role", "img", "aria-hidden", "true", 3, "svgIcon"], ["mat-list-item", "", "target", "_blank", 3, "href"]], template: function SideNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-nav-list", 0);
        ɵngcc0.ɵɵtemplate(1, SideNavComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.links);
    } }, directives: [ɵngcc2.MatNavList, ɵngcc3.NgForOf, ɵngcc3.NgIf, ɵngcc2.MatListItem, ɵngcc1.RouterLinkWithHref, ɵngcc1.RouterLinkActive, ɵngcc3.NgClass, ɵngcc4.DefaultClassDirective, ɵngcc5.DefaultFlexDirective, ɵngcc6.MatIcon], pipes: [ɵngcc3.AsyncPipe], styles: ["a[_ngcontent-%COMP%]   div.selected-icon[_ngcontent-%COMP%]{border-left:3px solid;border-radius:6px;margin-right:12px;width:0;display:none;align-self:stretch}a.active-link.active-fragment[_ngcontent-%COMP%]   div.selected-icon[_ngcontent-%COMP%]{display:inline}"] });
SideNavComponent.ctorParameters = () => [
    { type: ActivatedRoute }
];
SideNavComponent.propDecorators = {
    links: [{ type: Input }],
    defaultFragment: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideNavComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-side-nav',
                template: "<mat-nav-list class=\"atlas-side-nav\">\n  <ng-container *ngFor=\"let item of links; let cIdx = index\">\n    <a\n      *ngIf=\"item?.link !== ''\"\n      mat-list-item\n      [routerLink]=\"[item?.link]\"\n      [fragment]=\"item?.fragment\"\n      routerLinkActive=\"active-link\"\n      [ngClass]=\"{\n        'active-fragment': (route.fragment | async) === item?.fragment\n          || item?.fragment === ''\n          || !item?.fragment\n          || (item?.fragment?.length > 0 && item?.fragment === defaultFragment && ((route.fragment | async) == null))\n      }\">\n      <div class=\"selected-icon\"></div>\n      <span>{{ item?.label }}</span>\n      <span fxFlex=\"1 1 auto\"></span>\n      <mat-icon\n        *ngIf=\"item?.icon\"\n        role=\"img\"\n        aria-hidden=\"true\"\n        [svgIcon]=\"item?.icon\"\n      ></mat-icon>\n    </a>\n    <a\n      *ngIf=\"item?.externalLink\"\n      mat-list-item\n      [href]=\"[item?.externalLink]\"\n      target=\"_blank\"\n      >\n      <span>{{ item?.label }}</span>\n      <span fxFlex=\"1 1 auto\"></span>\n      <mat-icon\n        *ngIf=\"item?.icon\"\n        role=\"img\"\n        aria-hidden=\"true\"\n        [svgIcon]=\"item?.icon\"\n      ></mat-icon>\n    </a>\n  </ng-container>\n</mat-nav-list>\n",
                styles: ["a div.selected-icon{border-left:3px solid;border-radius:6px;margin-right:12px;width:0;display:none;align-self:stretch}a.active-link.active-fragment div.selected-icon{display:inline}"]
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }]; }, { links: [{
            type: Input
        }], defaultFragment: [{
            type: Input
        }] }); })();

class SideNavModule {
}
SideNavModule.ɵfac = function SideNavModule_Factory(t) { return new (t || SideNavModule)(); };
SideNavModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SideNavModule });
SideNavModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatListModule,
            MatIconModule,
            FlexLayoutModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SideNavModule, { declarations: function () { return [SideNavComponent]; }, imports: function () { return [CommonModule,
        MatListModule,
        MatIconModule,
        FlexLayoutModule,
        RouterModule]; }, exports: function () { return [SideNavComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideNavModule, [{
        type: NgModule,
        args: [{
                declarations: [SideNavComponent],
                imports: [
                    CommonModule,
                    MatListModule,
                    MatIconModule,
                    FlexLayoutModule,
                    RouterModule,
                ],
                exports: [
                    SideNavComponent
                ]
            }]
    }], null, null); })();

var VisibilityState;
(function (VisibilityState) {
    VisibilityState["Visible"] = "visible";
    VisibilityState["Hidden"] = "hidden";
    VisibilityState["Relative"] = "relative";
})(VisibilityState || (VisibilityState = {}));
var Direction;
(function (Direction) {
    Direction["Up"] = "Up";
    Direction["Down"] = "Down";
    Direction["Fixed"] = "Fixed";
})(Direction || (Direction = {}));
class StickyHeaderComponent {
    constructor(scrollDispatcher, zone) {
        this.scrollDispatcher = scrollDispatcher;
        this.zone = zone;
        this.threshold = 0;
        this.disable = false;
        this.isResultsLoading = false;
        this.isVisible = true;
        this.ngUnsubscribe = new Subject();
    }
    ngAfterViewInit() {
        let diff = 0;
        this.scrollDispatcher.scrolled().pipe(throttleTime(20), map(scroll => {
            if (scroll instanceof CdkScrollable) {
                return scroll.measureScrollOffset('top');
            }
        }), pairwise(), map(([y1, y2]) => {
            if (y2 === undefined || y2 <= this.threshold) {
                return Direction.Fixed;
            }
            else {
                return (y2 < y1 ? Direction.Up : Direction.Down);
            }
        }), distinctUntilChanged(), share(), takeUntil(this.ngUnsubscribe)).subscribe(direction => {
            // Scroll Dispatcher runs the scrolled events outside of the Angular Zone.
            // To get change detection to pick up the change, we need to run the model
            // updates back in the Angular Zone.
            this.zone.run(() => {
                this.isVisible = (direction === Direction.Up || direction === Direction.Fixed || this.isResultsLoading);
                this.isResultsLoading = false;
            });
        });
        setTimeout(_ => {
            this.containerHeight = this.container.nativeElement.offsetHeight;
            this.threshold = this.containerHeight;
        }, 0);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
    getToggle() {
        if (this.disable) {
            return VisibilityState.Relative;
        }
        return this.isVisible ? VisibilityState.Visible : VisibilityState.Hidden;
    }
}
StickyHeaderComponent.ɵfac = function StickyHeaderComponent_Factory(t) { return new (t || StickyHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.ScrollDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
StickyHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StickyHeaderComponent, selectors: [["atlas-sticky-header"]], viewQuery: function StickyHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, inputs: { threshold: "threshold", disable: "disable", isResultsLoading: "isResultsLoading" }, ngContentSelectors: _c5, decls: 4, vars: 8, consts: [[1, "sticky-content", 3, "ngStyle"], ["container", ""], [1, "placeholder", 3, "ngStyle"]], template: function StickyHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("@toggle", ctx.getToggle())("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c3, ctx.disable ? "relative" : "fixed"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction2(5, _c4, ctx.containerHeight + "px", ctx.disable ? "none" : "block"));
    } }, directives: [ɵngcc3.NgStyle], styles: ["div.sticky-content[_ngcontent-%COMP%]{width:100%;z-index:9}div.placeholder[_ngcontent-%COMP%]{position:relative;width:100%}"], data: { animation: [
            trigger('toggle', [
                state('hidden', style({ opacity: 0, transform: 'translateY(-100%)' })),
                state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                transition('* => *', animate('200ms ease-in'))
            ])
        ] } });
StickyHeaderComponent.ctorParameters = () => [
    { type: ScrollDispatcher },
    { type: NgZone }
];
StickyHeaderComponent.propDecorators = {
    threshold: [{ type: Input }],
    disable: [{ type: Input }],
    isResultsLoading: [{ type: Input }],
    container: [{ type: ViewChild, args: ['container', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-sticky-header',
                template: "<div [@toggle]=\"getToggle()\" class=\"sticky-content\" #container [ngStyle]=\"{'position': disable ? 'relative' : 'fixed'}\">\n  <ng-content></ng-content>\n</div>\n<div class=\"placeholder\" [ngStyle]=\"{'height': containerHeight+'px', 'display': disable ? 'none' : 'block'}\"></div>",
                animations: [
                    trigger('toggle', [
                        state('hidden', style({ opacity: 0, transform: 'translateY(-100%)' })),
                        state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                        transition('* => *', animate('200ms ease-in'))
                    ])
                ],
                styles: ["div.sticky-content{width:100%;z-index:9}div.placeholder{position:relative;width:100%}"]
            }]
    }], function () { return [{ type: ɵngcc7.ScrollDispatcher }, { type: ɵngcc0.NgZone }]; }, { threshold: [{
            type: Input
        }], disable: [{
            type: Input
        }], isResultsLoading: [{
            type: Input
        }], container: [{
            type: ViewChild,
            args: ['container', { static: true }]
        }] }); })();

class StickyHeaderModule {
}
StickyHeaderModule.ɵfac = function StickyHeaderModule_Factory(t) { return new (t || StickyHeaderModule)(); };
StickyHeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: StickyHeaderModule });
StickyHeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StickyHeaderModule, { declarations: function () { return [StickyHeaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [StickyHeaderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyHeaderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    StickyHeaderComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    StickyHeaderComponent
                ]
            }]
    }], null, null); })();

class SearchBarComponent {
    constructor() {
        this.id = 'searchbar';
        this.placeholder = '';
        this.control = null;
        this.autoComplete = false;
        this.active = new EventEmitter();
        this.optionSelected = new EventEmitter();
    }
    ngOnInit() {
    }
}
SearchBarComponent.ɵfac = function SearchBarComponent_Factory(t) { return new (t || SearchBarComponent)(); };
SearchBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SearchBarComponent, selectors: [["atlas-search-bar"]], hostVars: 2, hostBindings: function SearchBarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("search-active", ctx.isActive);
    } }, inputs: { id: "id", placeholder: "placeholder", control: "control", autoComplete: "autoComplete" }, outputs: { active: "active", optionSelected: "optionSelected" }, ngContentSelectors: _c5, decls: 1, vars: 1, consts: [["class", "atlas-search-bar", 4, "ngIf"], [1, "atlas-search-bar"], ["role", "img", "aria-hidden", "true", "svgIcon", "mma-find-care-search", 1, "search-icon"], [4, "ngIf"], ["type", "search", 3, "placeholder", "formControl", "focus", "focusout"], ["type", "search", 3, "placeholder", "formControl", "matAutocomplete", "focus", "focusout"], [3, "optionSelected"], ["auto", "matAutocomplete"]], template: function SearchBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, SearchBarComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.control);
    } }, directives: [ɵngcc3.NgIf, ɵngcc6.MatIcon, ɵngcc8.DefaultValueAccessor, ɵngcc8.NgControlStatus, ɵngcc8.FormControlDirective, ɵngcc9.MatAutocompleteTrigger, ɵngcc9.MatAutocomplete], styles: ["[_nghost-%COMP%]{border-radius:3px}div.search-bar[_ngcontent-%COMP%]{min-width:200px;position:relative}div.search-bar[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{position:absolute;left:8px;top:7px}div.search-bar[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background:none;border:0;outline:0;padding:8px 8px 8px 40px;width:100%;-webkit-appearance:initial}"] });
SearchBarComponent.ctorParameters = () => [];
SearchBarComponent.propDecorators = {
    isActive: [{ type: HostBinding, args: ['class.search-active',] }],
    id: [{ type: Input }],
    placeholder: [{ type: Input }],
    control: [{ type: Input }],
    autoComplete: [{ type: Input }],
    active: [{ type: Output }],
    optionSelected: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchBarComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-search-bar',
                template: "<div class=\"atlas-search-bar\" *ngIf=\"control\">\n  <!-- Search Bar Icon -->\n  <mat-icon role=\"img\" aria-hidden=\"true\" class=\"search-icon\" svgIcon=\"mma-find-care-search\"></mat-icon>\n\n  <!-- Search Bar Input without Auto-complete -->\n  <ng-container *ngIf=\"!autoComplete\">\n    <input type=\"search\" [attr.id]=\"id\" [placeholder]=\"placeholder\" [attr.aria-label]=\"placeholder\"\n      [formControl]=\"control\" (focus)=\"active.emit(true); isActive=true\"\n      (focusout)=\"active.emit(false); isActive=false\" />\n  </ng-container>\n\n  <!-- Search Bar Input with Auto-complete-->\n  <ng-container *ngIf=\"autoComplete\">\n    <input type=\"search\" [attr.id]=\"id\" [placeholder]=\"placeholder\" [attr.aria-label]=\"placeholder\"\n      [formControl]=\"control\" (focus)=\"active.emit(true); isActive=true\"\n      (focusout)=\"active.emit(false); isActive=false\" [matAutocomplete]=\"auto\"/>\n\n    <!-- Auto-complete suggestions through content projection -->\n    <mat-autocomplete #auto=\"matAutocomplete\" (optionSelected)=\"optionSelected.emit($event)\">\n      <ng-content></ng-content>\n    </mat-autocomplete>\n  </ng-container>\n</div>",
                styles: [":host{border-radius:3px}div.search-bar{min-width:200px;position:relative}div.search-bar mat-icon{position:absolute;left:8px;top:7px}div.search-bar input{background:none;border:0;outline:0;padding:8px 8px 8px 40px;width:100%;-webkit-appearance:initial}"]
            }]
    }], function () { return []; }, { id: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], control: [{
            type: Input
        }], autoComplete: [{
            type: Input
        }], active: [{
            type: Output
        }], optionSelected: [{
            type: Output
        }], isActive: [{
            type: HostBinding,
            args: ['class.search-active']
        }] }); })();

class SearchBarModule {
}
SearchBarModule.ɵfac = function SearchBarModule_Factory(t) { return new (t || SearchBarModule)(); };
SearchBarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SearchBarModule });
SearchBarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            MatAutocompleteModule,
            MatIconModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SearchBarModule, { declarations: function () { return [SearchBarComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatIconModule]; }, exports: function () { return [SearchBarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchBarModule, [{
        type: NgModule,
        args: [{
                declarations: [SearchBarComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatAutocompleteModule,
                    MatIconModule,
                ],
                exports: [
                    SearchBarComponent
                ]
            }]
    }], null, null); })();

class CarouselItemComponent {
    constructor(el) {
        this.el = el;
    }
    get marginLeft() {
        return this.index > 0 ? 1 : 0;
    }
    get index() {
        return this._index;
    }
    set index(val) {
        this._index = val;
    }
    ngOnInit() {
    }
    set minWidth(min) {
        this.el.nativeElement.style.minWidth = min + 'px';
    }
    set maxWidth(max) {
        this.el.nativeElement.style.maxWidth = max + 'px';
    }
    get offsetLeft() {
        return this.el.nativeElement.offsetLeft;
    }
    get offsetRight() {
        return this.el.nativeElement.offsetLeft + this.el.nativeElement.offsetWidth;
    }
    get offsetWidth() {
        return this.el.nativeElement.offsetWidth;
    }
}
CarouselItemComponent.ɵfac = function CarouselItemComponent_Factory(t) { return new (t || CarouselItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
CarouselItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CarouselItemComponent, selectors: [["atlas-carousel-item"]], hostVars: 2, hostBindings: function CarouselItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("margin-left", ctx.marginLeft, "rem");
    } }, ngContentSelectors: _c5, decls: 3, vars: 0, consts: [["itemContainer", ""]], template: function CarouselItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: ["[_nghost-%COMP%]{display:inline-block;z-index:1}"] });
CarouselItemComponent.ctorParameters = () => [
    { type: ElementRef }
];
CarouselItemComponent.propDecorators = {
    marginLeft: [{ type: HostBinding, args: ['style.margin-left.rem',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselItemComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-carousel-item',
                template: '<div #itemContainer>' +
                    '<ng-content></ng-content>' +
                    '</div>',
                styles: [":host{display:inline-block;z-index:1}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { marginLeft: [{
            type: HostBinding,
            args: ['style.margin-left.rem']
        }] }); })();

/**
 * Carousel component for a slide/scroll container
 *
 * Example:
 * <atlas-carousel [minWidth]="0.7" [maxWidth]="0.8" [arrows]="true">
 *  <ng-container *ngFor="let i of [1,2,3,4,5,6,7,8,9]">
 *    <atlas-carousel-item>
 *      <!-- content inside each carousel item -->
 *    </atlas-carousel-item>
 *  </ng-container>
 * </atlas-carousel>
 */
class CarouselComponent {
    constructor(scrollDispatcher, zone) {
        this.scrollDispatcher = scrollDispatcher;
        this.zone = zone;
        this._ngUnsubscribe = new Subject();
        this._activeIndex = 0;
        this._itemsArray = [];
        this._minWidth = 0;
        this._maxWidth = 0;
        this._leftIcon = 'matlocal-chevron-left';
        this._rightIcon = 'matlocal-chevron-right';
        this._arrows = false;
        /**
         * @output {void} Emitted when a item change ends.
         */
        this.itemDidChange = new EventEmitter();
        /**
         * @output {void} Emitted when the carousel reaches its beginning (initial position).
         */
        this.carouselReachStart = new EventEmitter();
        /**
         * @output {void} Emitted when the carousel reaches its last item.
         */
        this.carouselReachEnd = new EventEmitter();
    }
    get carouselWidth() {
        return this._carousel.nativeElement.offsetWidth;
    }
    /**
     * @input {number} Optional decimal percentage for min width of carousel item
     */
    get minWidth() {
        return this._minWidth;
    }
    set minWidth(val) {
        this._minWidth = val;
    }
    /**
     * @input {number} Optional decimal percentage for max width of carousel item
     */
    get maxWidth() {
        return this._maxWidth;
    }
    set maxWidth(val) {
        this._maxWidth = val;
    }
    /**
     * @input {string} Set to override the default previous button icon
     */
    get leftIcon() {
        return this._leftIcon;
    }
    set leftIcon(val) {
        this._leftIcon = val;
    }
    /**
     * @input {string} Set to override the default next button icon
     */
    get rightIcon() {
        return this._rightIcon;
    }
    set rightIcon(val) {
        this._rightIcon = val;
    }
    /**
     * @input {boolean} If true, will display the next/previous navigation arrows
     */
    get arrows() {
        return this._arrows;
    }
    set arrows(val) {
        this._arrows = val;
    }
    /**
     * Sets the min and max width of the elements in the carousel if min/max are provided
     * Min and Max values should be percent decimal value between 0 and 1.
     * Ex: 0.8 = 80%
     */
    initialize() {
        let setMinMax = (this.minWidth > 0 && this.maxWidth > 0 && this.minWidth <= 1 && this.maxWidth <= 1 && this.minWidth <= this.maxWidth);
        const max = this.carouselWidth * this.maxWidth;
        const min = this.carouselWidth * this.minWidth;
        this._itemsArray = this._items.toArray();
        this._items.forEach((item, itemIndex) => {
            item.index = itemIndex;
            if (setMinMax) {
                item.maxWidth = max;
                item.minWidth = min;
            }
        });
    }
    /**
     * Gets the active index based on which carousel item is currently crossing the center plane of the carousel
     * @param offset
     * @param offsetCenter
     */
    getActiveIndexForScroll(offset, offsetCenter) {
        if (offset > 0) {
            for (let i = 0; i < this._itemsArray.length; i++) {
                let item = this._itemsArray[i];
                // TODO: 16px is relative for 1rem, should actually get px value of a rem.
                let left = (item.index > 0) ? item.offsetLeft - 16 : item.offsetLeft;
                if (left <= offsetCenter && item.offsetRight >= offsetCenter) {
                    return i;
                }
            }
        }
        else {
            return 0;
        }
    }
    /**
     * Handles updating the active index to the next item index.
     * If the index have changed, emit appropriate events (did change, start, end)
     * @param nextIndex
     */
    updateActiveIndex(nextIndex) {
        let didChange = (nextIndex !== this._activeIndex);
        this._activeIndex = nextIndex;
        if (didChange) {
            this.itemDidChange.emit();
            if (this.isBeginning()) {
                this.carouselReachStart.emit();
            }
            if (this.isEnd()) {
                this.carouselReachEnd.emit();
            }
        }
    }
    /**
     * Subscribes to the ScrollDispatchers scrolled observable.
     * Ignores scrolling on other scroll containers except the carousel's CdkScrollable container.
     * Updates the Active Index to which the user has scrolled to.
     */
    setupScrollListener() {
        this.scrollDispatcher.scrolled().pipe(debounceTime(200), map(scroll => {
            if (scroll && scroll === this._scroll) {
                return scroll.measureScrollOffset('left');
            }
            return null;
        }), takeUntil(this._ngUnsubscribe)).subscribe(offset => {
            if (offset !== null) {
                let offsetCentered = offset + (this.carouselWidth / 2);
                let nextIndex = this.getActiveIndexForScroll(offset, offsetCentered);
                this.zone.run(() => {
                    this.updateActiveIndex(nextIndex);
                });
            }
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.initialize();
        }, 0);
        // ScrollDispatcher scrollContainers returns a map of all registered CdkScrollable elements.
        // This will find the matching CdkScrollable that is setup for the Carousel.
        this.scrollDispatcher.scrollContainers.forEach((value, key) => {
            if (key instanceof CdkScrollable && key.getElementRef().nativeElement === this._carousel.nativeElement) {
                this._scroll = key;
            }
        });
        this.setupScrollListener();
    }
    ngOnDestroy() {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }
    /**
     * Scrolls to the specified index if its in rage.
     * @param index
     * @param speed
     * @param runCallbacks
     */
    slideTo(index, dir, runCallbacks) {
        if (index >= 0 && index < this._itemsArray.length) {
            const currentItem = this._itemsArray[index];
            let offset = currentItem.offsetLeft;
            if (dir === 'prev') {
                const containerWidth = this.carouselWidth;
                const subtract = containerWidth - currentItem.offsetWidth;
                offset = offset - subtract;
            }
            this._scroll.scrollTo({
                top: 0,
                left: offset,
                behavior: 'smooth'
            });
            this.updateActiveIndex(index);
        }
    }
    /**
     * Scrolls to the next item
     * @param speed
     * @param runCallbacks
     */
    slideNext(runCallbacks) {
        this.slideTo(this._activeIndex + 1, 'next', runCallbacks);
    }
    /**
     * Scrolls to the previous item
     * @param speed
     * @param runCallbacks
     */
    slidePrev(runCallbacks) {
        this.slideTo(this._activeIndex - 1, 'prev', runCallbacks);
    }
    /**
     * Returns the active item index
     */
    getActiveIndex() {
        return this._activeIndex;
    }
    /**
     * Returns the number of items in the carousel
     */
    length() {
        return this._items.length;
    }
    /**
     * Returns true if the active item is the last one in the carousel
     */
    isEnd() {
        return this._activeIndex === this._items.length - 1;
    }
    /**
     * Returns true if the active item is the rirst one in the carousel
     */
    isBeginning() {
        return this._activeIndex === 0;
    }
}
CarouselComponent.ɵfac = function CarouselComponent_Factory(t) { return new (t || CarouselComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.ScrollDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
CarouselComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CarouselComponent, selectors: [["atlas-carousel"]], contentQueries: function CarouselComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CarouselItemComponent, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._items = _t);
    } }, viewQuery: function CarouselComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 3);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._carousel = _t.first);
    } }, inputs: { minWidth: "minWidth", maxWidth: "maxWidth", leftIcon: "leftIcon", rightIcon: "rightIcon", arrows: "arrows" }, outputs: { itemDidChange: "itemDidChange", carouselReachStart: "carouselReachStart", carouselReachEnd: "carouselReachEnd" }, ngContentSelectors: _c5, decls: 6, vars: 4, consts: [["cdkScrollable", "", 1, "carousel-container"], ["atlasCarousel", ""], [1, "items-container", 3, "ngClass"], ["itemsContainer", ""], [4, "ngIf"], [1, "arrows-container"], ["arrowContainer", ""], ["mat-mini-fab", "", "aria-label", "next slide", "class", "next-button", 3, "click", 4, "ngIf"], ["mat-mini-fab", "", "aria-label", "previous slide", "class", "prev-button", 3, "click", 4, "ngIf"], ["mat-mini-fab", "", "aria-label", "next slide", 1, "next-button", 3, "click"], [3, "svgIcon"], ["mat-mini-fab", "", "aria-label", "previous slide", 1, "prev-button", 3, "click"]], template: function CarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵprojection(4, 0, ["#items", ""]);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, CarouselComponent_ng_container_5_Template, 5, 2, "ng-container", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c7, ctx.arrows));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrows);
    } }, directives: [ɵngcc10.CdkScrollable, ɵngcc3.NgClass, ɵngcc3.NgIf, ɵngcc11.MatButton, ɵngcc6.MatIcon], styles: ["[_nghost-%COMP%]{position:relative;width:100%;display:block}.carousel-container[_ngcontent-%COMP%]{position:relative;width:inherit;height:100%;overflow-x:auto;overflow-y:hidden;white-space:nowrap;-ms-overflow-style:none;scrollbar-width:none}.carousel-container[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.items-container[_ngcontent-%COMP%]{display:inline-block;position:relative;padding:1rem}.items-container.show-arrows[_ngcontent-%COMP%]{padding:1rem 0}.arrows-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{opacity:.9;position:absolute;margin-top:auto;margin-bottom:auto;top:0;bottom:0;z-index:2}.arrows-container[_ngcontent-%COMP%]   button.next-button[_ngcontent-%COMP%]{right:9px}.arrows-container[_ngcontent-%COMP%]   button.prev-button[_ngcontent-%COMP%]{left:-20px}"] });
CarouselComponent.ctorParameters = () => [
    { type: ScrollDispatcher },
    { type: NgZone }
];
CarouselComponent.propDecorators = {
    _items: [{ type: ContentChildren, args: [CarouselItemComponent,] }],
    _carousel: [{ type: ViewChild, args: ['atlasCarousel', { static: true },] }],
    minWidth: [{ type: Input }],
    maxWidth: [{ type: Input }],
    leftIcon: [{ type: Input }],
    rightIcon: [{ type: Input }],
    arrows: [{ type: Input }],
    itemDidChange: [{ type: Output }],
    carouselReachStart: [{ type: Output }],
    carouselReachEnd: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-carousel',
                template: "<div #atlasCarousel class=\"carousel-container\" cdkScrollable>\n  <div #itemsContainer class=\"items-container\" [ngClass]=\"{ 'show-arrows': arrows }\">\n    <ng-content #items></ng-content>\n  </div>\n</div>\n<ng-container *ngIf=\"arrows\">\n  <div #arrowContainer class=\"arrows-container\">\n    <button mat-mini-fab aria-label=\"next slide\" (click)=\"slideNext()\" *ngIf=\"!isEnd()\" class=\"next-button\">\n      <mat-icon [svgIcon]=\"rightIcon\"></mat-icon>\n    </button>\n    <button mat-mini-fab aria-label=\"previous slide\" (click)=\"slidePrev()\" *ngIf=\"!isBeginning()\" class=\"prev-button\">\n      <mat-icon [svgIcon]=\"leftIcon\"></mat-icon>\n    </button>\n  </div>\n</ng-container>",
                styles: [":host{position:relative;width:100%;display:block}.carousel-container{position:relative;width:inherit;height:100%;overflow-x:auto;overflow-y:hidden;white-space:nowrap;-ms-overflow-style:none;scrollbar-width:none}.carousel-container::-webkit-scrollbar{display:none}.items-container{display:inline-block;position:relative;padding:1rem}.items-container.show-arrows{padding:1rem 0}.arrows-container button{opacity:.9;position:absolute;margin-top:auto;margin-bottom:auto;top:0;bottom:0;z-index:2}.arrows-container button.next-button{right:9px}.arrows-container button.prev-button{left:-20px}"]
            }]
    }], function () { return [{ type: ɵngcc7.ScrollDispatcher }, { type: ɵngcc0.NgZone }]; }, { itemDidChange: [{
            type: Output
        }], carouselReachStart: [{
            type: Output
        }], carouselReachEnd: [{
            type: Output
        }], minWidth: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], leftIcon: [{
            type: Input
        }], rightIcon: [{
            type: Input
        }], arrows: [{
            type: Input
        }], _items: [{
            type: ContentChildren,
            args: [CarouselItemComponent]
        }], _carousel: [{
            type: ViewChild,
            args: ['atlasCarousel', { static: true }]
        }] }); })();

class CarouselModule {
}
CarouselModule.ɵfac = function CarouselModule_Factory(t) { return new (t || CarouselModule)(); };
CarouselModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CarouselModule });
CarouselModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatIconModule,
            MatButtonModule,
            ScrollingModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CarouselModule, { declarations: function () { return [CarouselComponent, CarouselItemComponent]; }, imports: function () { return [CommonModule,
        MatIconModule,
        MatButtonModule,
        ScrollingModule]; }, exports: function () { return [CarouselComponent, CarouselItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselModule, [{
        type: NgModule,
        args: [{
                declarations: [CarouselComponent, CarouselItemComponent],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatButtonModule,
                    ScrollingModule
                ],
                exports: [CarouselComponent, CarouselItemComponent]
            }]
    }], null, null); })();

class AccordionComponent {
    constructor() { }
    ngOnInit() {
    }
}
AccordionComponent.ɵfac = function AccordionComponent_Factory(t) { return new (t || AccordionComponent)(); };
AccordionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AccordionComponent, selectors: [["atlas-accordion"]], ngContentSelectors: _c9, decls: 2, vars: 0, consts: [["displayMode", "'flat'"]], template: function AccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c8);
        ɵngcc0.ɵɵelementStart(0, "mat-accordion", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc12.MatAccordion], encapsulation: 2 });
AccordionComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-accordion',
                template: "<mat-accordion displayMode=\"'flat'\">\n  <ng-content select=\"mat-expansion-panel\"></ng-content>\n</mat-accordion>"
            }]
    }], function () { return []; }, null); })();

class AccordionModule {
}
AccordionModule.ɵfac = function AccordionModule_Factory(t) { return new (t || AccordionModule)(); };
AccordionModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AccordionModule });
AccordionModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatExpansionModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccordionModule, { declarations: function () { return [AccordionComponent]; }, imports: function () { return [CommonModule,
        MatExpansionModule]; }, exports: function () { return [AccordionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AccordionModule, [{
        type: NgModule,
        args: [{
                declarations: [AccordionComponent],
                imports: [
                    CommonModule,
                    MatExpansionModule
                ],
                exports: [
                    AccordionComponent
                ]
            }]
    }], null, null); })();

class SliderComponent {
    constructor() {
        this.displayValue = true;
        this.displayLabel = true;
        this.invert = false;
        this.thumbLabel = false;
        this.vertical = false;
        this.disabled = false;
        this.sliderValue = new EventEmitter();
    }
    emitChange(val) {
        this.sliderValue.emit({
            value: val
        });
    }
}
SliderComponent.ɵfac = function SliderComponent_Factory(t) { return new (t || SliderComponent)(); };
SliderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SliderComponent, selectors: [["atlas-slider"]], inputs: { displayValue: "displayValue", displayLabel: "displayLabel", invert: "invert", thumbLabel: "thumbLabel", vertical: "vertical", disabled: "disabled", min: "min", max: "max", labelContent: "labelContent", step: "step", tickInterval: "tickInterval" }, outputs: { sliderValue: "sliderValue" }, decls: 12, vars: 15, consts: [[1, "atlas-slider-container"], [1, "atlas-slider-left"], [1, "atlas-slider-content"], ["class", "label", 3, "ngClass", 4, "ngIf"], [1, "atlas-slider-content-2"], [3, "ngClass"], [3, "disabled", "invert", "min", "max", "step", "thumbLabel", "tickInterval", "ngModel", "vertical", "ngModelChange", "change"], [1, "atlas-slider-right"], [4, "ngIf"], [1, "label", 3, "ngClass"], ["matInput", "", "type", "number", 3, "ngModel", "min", "max", "disabled", "ngModelChange"]], template: function SliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, SliderComponent_p_3_Template, 2, 2, "p", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "p", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "mat-slider", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function SliderComponent_Template_mat_slider_ngModelChange_7_listener($event) { return ctx.sliderValue = $event; })("change", function SliderComponent_Template_mat_slider_change_7_listener() { return ctx.emitChange(ctx.sliderValue); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "p", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtemplate(11, SliderComponent_mat_form_field_11_Template, 2, 4, "mat-form-field", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.disabled === true ? "disabled-content" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.min);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("invert", ctx.invert)("min", ctx.min)("max", ctx.max)("step", ctx.step)("thumbLabel", ctx.thumbLabel)("tickInterval", ctx.tickInterval)("ngModel", ctx.sliderValue)("vertical", ctx.vertical);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.disabled === true ? "disabled-content" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.max);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayValue);
    } }, directives: [ɵngcc3.NgIf, ɵngcc3.NgClass, ɵngcc13.MatSlider, ɵngcc8.NgControlStatus, ɵngcc8.NgModel, ɵngcc14.MatFormField, ɵngcc15.MatInput, ɵngcc8.NumberValueAccessor, ɵngcc8.DefaultValueAccessor], styles: [""] });
SliderComponent.ctorParameters = () => [];
SliderComponent.propDecorators = {
    min: [{ type: Input }],
    max: [{ type: Input }],
    displayValue: [{ type: Input }],
    displayLabel: [{ type: Input }],
    labelContent: [{ type: Input }],
    step: [{ type: Input }],
    invert: [{ type: Input }],
    thumbLabel: [{ type: Input }],
    tickInterval: [{ type: Input }],
    vertical: [{ type: Input }],
    disabled: [{ type: Input }],
    sliderValue: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SliderComponent, [{
        type: Component,
        args: [{
                selector: 'atlas-slider',
                template: "<div class=\"atlas-slider-container\">\n    <div class=\"atlas-slider-left\">\n        \n        <div class=\"atlas-slider-content\">\n            <p *ngIf=\"displayLabel\" class=\"label\" [ngClass]=\"(disabled === true)?'disabled-content': ''\">{{labelContent}}</p>\n            <div class=\"atlas-slider-content-2\">\n                <p [ngClass]=\"(disabled === true)?'disabled-content': ''\">{{min}}</p>\n                <mat-slider [disabled]=\"disabled\"\n                            [invert]=\"invert\"\n                            [min]=\"min\"\n                            [max]=\"max\"\n                            [step]=\"step\"\n                            [thumbLabel]=\"thumbLabel\"\n                            [tickInterval]=\"tickInterval\"\n                            [(ngModel)]=\"sliderValue\"\n                            (change)=\"emitChange(sliderValue)\"\n                            [vertical]=\"vertical\">\n\n                </mat-slider>\n                <p [ngClass]=\"(disabled === true)?'disabled-content': ''\">{{max}}</p>\n            </div>\n        </div>\n    </div>\n    <div class=\"atlas-slider-right\">\n        <mat-form-field *ngIf=\"displayValue\">\n            <input matInput type=\"number\" [(ngModel)]=\"sliderValue\" [min]=\"min\" [max]=\"max\" [disabled]=\"disabled\">\n        </mat-form-field>\n    </div>\n</div>\n",
                styles: [""]
            }]
    }], function () { return []; }, { displayValue: [{
            type: Input
        }], displayLabel: [{
            type: Input
        }], invert: [{
            type: Input
        }], thumbLabel: [{
            type: Input
        }], vertical: [{
            type: Input
        }], disabled: [{
            type: Input
        }], sliderValue: [{
            type: Output
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], labelContent: [{
            type: Input
        }], step: [{
            type: Input
        }], tickInterval: [{
            type: Input
        }] }); })();

class SliderModule {
}
SliderModule.ɵfac = function SliderModule_Factory(t) { return new (t || SliderModule)(); };
SliderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SliderModule });
SliderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            MatSliderModule,
            MatInputModule,
            MatFormFieldModule,
            FormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SliderModule, { declarations: function () { return [SliderComponent]; }, imports: function () { return [CommonModule,
        MatSliderModule,
        MatInputModule,
        MatFormFieldModule,
        FormsModule]; }, exports: function () { return [SliderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SliderModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SliderComponent
                ],
                imports: [
                    CommonModule,
                    MatSliderModule,
                    MatInputModule,
                    MatFormFieldModule,
                    FormsModule,
                ],
                exports: [
                    SliderComponent
                ]
            }]
    }], null, null); })();

class AtlasXSmallButtonDirective {
}
AtlasXSmallButtonDirective.ɵfac = function AtlasXSmallButtonDirective_Factory(t) { return new (t || AtlasXSmallButtonDirective)(); };
AtlasXSmallButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasXSmallButtonDirective, selectors: [["button", "atlas-x-small", ""]], hostAttrs: [1, "atlas-x-small"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasXSmallButtonDirective, [{
        type: Directive,
        args: [{
                selector: "button[atlas-x-small]",
                host: { class: "atlas-x-small" }
            }]
    }], null, null); })();
class AtlasSmallButtonDirective {
}
AtlasSmallButtonDirective.ɵfac = function AtlasSmallButtonDirective_Factory(t) { return new (t || AtlasSmallButtonDirective)(); };
AtlasSmallButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasSmallButtonDirective, selectors: [["button", "atlas-small", ""]], hostAttrs: [1, "atlas-small"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasSmallButtonDirective, [{
        type: Directive,
        args: [{
                selector: "button[atlas-small]",
                host: { class: "atlas-small" }
            }]
    }], null, null); })();
class AtlasLargeButtonDirective {
}
AtlasLargeButtonDirective.ɵfac = function AtlasLargeButtonDirective_Factory(t) { return new (t || AtlasLargeButtonDirective)(); };
AtlasLargeButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasLargeButtonDirective, selectors: [["button", "atlas-large", ""]], hostAttrs: [1, "atlas-large"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasLargeButtonDirective, [{
        type: Directive,
        args: [{
                selector: "button[atlas-large]",
                // tslint:disable-next-line:no-host-metadata-property
                host: { class: "atlas-large" }
            }]
    }], null, null); })();
class AtlasMediumButtonDirective {
}
AtlasMediumButtonDirective.ɵfac = function AtlasMediumButtonDirective_Factory(t) { return new (t || AtlasMediumButtonDirective)(); };
AtlasMediumButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasMediumButtonDirective, selectors: [["button", "atlas-medium", ""], ["button", 3, "atlas-small", "", 3, "atlas-large", "", 3, "atlas-x-small", "", 3, "atlas-x-small-light", ""]], hostAttrs: [1, "atlas-medium"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasMediumButtonDirective, [{
        type: Directive,
        args: [{
                selector: 
                // tslint:disable-next-line:directive-selector
                "button[atlas-medium], button:not([atlas-small]):not([atlas-large]):not([atlas-x-small]):not([atlas-x-small-light])",
                // tslint:disable-next-line:no-host-metadata-property
                host: { class: "atlas-medium" }
            }]
    }], null, null); })();
class AtlasNavigationButtonDirective {
}
AtlasNavigationButtonDirective.ɵfac = function AtlasNavigationButtonDirective_Factory(t) { return new (t || AtlasNavigationButtonDirective)(); };
AtlasNavigationButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasNavigationButtonDirective, selectors: [["button", "atlas-nav-button", ""]], hostAttrs: [1, "atlas-nav-button"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasNavigationButtonDirective, [{
        type: Directive,
        args: [{
                selector: "button[atlas-nav-button]",
                host: { class: "atlas-nav-button" }
            }]
    }], null, null); })();
class AtlasXSmallLightButtonDirective {
}
AtlasXSmallLightButtonDirective.ɵfac = function AtlasXSmallLightButtonDirective_Factory(t) { return new (t || AtlasXSmallLightButtonDirective)(); };
AtlasXSmallLightButtonDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasXSmallLightButtonDirective, selectors: [["button", "atlas-x-small-light", ""]], hostAttrs: [1, "atlas-x-small-light"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasXSmallLightButtonDirective, [{
        type: Directive,
        args: [{
                selector: "button[atlas-x-small-light]",
                host: { class: "atlas-x-small-light" }
            }]
    }], null, null); })();

class AtlasButtonModule {
}
AtlasButtonModule.ɵfac = function AtlasButtonModule_Factory(t) { return new (t || AtlasButtonModule)(); };
AtlasButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AtlasButtonModule });
AtlasButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AtlasButtonModule, { declarations: function () { return [AtlasLargeButtonDirective, AtlasMediumButtonDirective, AtlasSmallButtonDirective, AtlasNavigationButtonDirective, AtlasXSmallButtonDirective, AtlasXSmallLightButtonDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AtlasLargeButtonDirective, AtlasMediumButtonDirective, AtlasSmallButtonDirective, AtlasNavigationButtonDirective, AtlasXSmallButtonDirective, AtlasXSmallLightButtonDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [AtlasLargeButtonDirective, AtlasMediumButtonDirective, AtlasSmallButtonDirective, AtlasNavigationButtonDirective, AtlasXSmallButtonDirective, AtlasXSmallLightButtonDirective],
                imports: [
                    CommonModule
                ],
                exports: [
                    AtlasLargeButtonDirective, AtlasMediumButtonDirective, AtlasSmallButtonDirective, AtlasNavigationButtonDirective, AtlasXSmallButtonDirective, AtlasXSmallLightButtonDirective
                ]
            }]
    }], null, null); })();

class AtlasLinkDirective {
}
AtlasLinkDirective.ɵfac = function AtlasLinkDirective_Factory(t) { return new (t || AtlasLinkDirective)(); };
AtlasLinkDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasLinkDirective, selectors: [["a", "atlas-link", ""]], hostAttrs: [1, "atlas-link"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasLinkDirective, [{
        type: Directive,
        args: [{
                selector: "a[atlas-link]",
                host: { class: "atlas-link" }
            }]
    }], null, null); })();

class AtlasLinkModule {
}
AtlasLinkModule.ɵfac = function AtlasLinkModule_Factory(t) { return new (t || AtlasLinkModule)(); };
AtlasLinkModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AtlasLinkModule });
AtlasLinkModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AtlasLinkModule, { declarations: function () { return [AtlasLinkDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AtlasLinkDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasLinkModule, [{
        type: NgModule,
        args: [{
                declarations: [AtlasLinkDirective],
                imports: [
                    CommonModule
                ],
                exports: [
                    AtlasLinkDirective
                ]
            }]
    }], null, null); })();

class MarginDirective {
}
MarginDirective.ɵfac = function MarginDirective_Factory(t) { return new (t || MarginDirective)(); };
MarginDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginDirective, selectors: [["", "margin", ""]], hostAttrs: [1, "margin"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginDirective, [{
        type: Directive,
        args: [{
                selector: "[margin]",
                host: { class: "margin" }
            }]
    }], null, null); })();
class NoMarginDirective {
}
NoMarginDirective.ɵfac = function NoMarginDirective_Factory(t) { return new (t || NoMarginDirective)(); };
NoMarginDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NoMarginDirective, selectors: [["", "no-margin", ""]], hostAttrs: [1, "margin-none"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoMarginDirective, [{
        type: Directive,
        args: [{
                selector: "[no-margin]",
                host: { class: "margin-none" }
            }]
    }], null, null); })();
class MarginVerticalDirective {
}
MarginVerticalDirective.ɵfac = function MarginVerticalDirective_Factory(t) { return new (t || MarginVerticalDirective)(); };
MarginVerticalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginVerticalDirective, selectors: [["", "margin-vertical", ""]], hostAttrs: [1, "margin-vertical"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginVerticalDirective, [{
        type: Directive,
        args: [{
                selector: "[margin-vertical]",
                host: { class: "margin-vertical" }
            }]
    }], null, null); })();
class MarginHorizontalDirective {
}
MarginHorizontalDirective.ɵfac = function MarginHorizontalDirective_Factory(t) { return new (t || MarginHorizontalDirective)(); };
MarginHorizontalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginHorizontalDirective, selectors: [["", "margin-horizontal", ""]], hostAttrs: [1, "margin-horizontal"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginHorizontalDirective, [{
        type: Directive,
        args: [{
                selector: "[margin-horizontal]",
                host: { class: "margin-horizontal" }
            }]
    }], null, null); })();
class MarginTopDirective {
}
MarginTopDirective.ɵfac = function MarginTopDirective_Factory(t) { return new (t || MarginTopDirective)(); };
MarginTopDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginTopDirective, selectors: [["", "margin-top", ""]], hostAttrs: [1, "margin-top"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginTopDirective, [{
        type: Directive,
        args: [{
                selector: "[margin-top]",
                host: { class: "margin-top" }
            }]
    }], null, null); })();
class MarginRightDirective {
}
MarginRightDirective.ɵfac = function MarginRightDirective_Factory(t) { return new (t || MarginRightDirective)(); };
MarginRightDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginRightDirective, selectors: [["", "margin-right", ""]], hostAttrs: [1, "margin-right"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginRightDirective, [{
        type: Directive,
        args: [{
                selector: "[margin-right]",
                host: { class: "margin-right" }
            }]
    }], null, null); })();
class MarginBottomDirective {
}
MarginBottomDirective.ɵfac = function MarginBottomDirective_Factory(t) { return new (t || MarginBottomDirective)(); };
MarginBottomDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginBottomDirective, selectors: [["", "margin-bottom", ""]], hostAttrs: [1, "margin-bottom"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginBottomDirective, [{
        type: Directive,
        args: [{
                selector: "[margin-bottom]",
                host: { class: "margin-bottom" }
            }]
    }], null, null); })();
class MarginLeftDirective {
}
MarginLeftDirective.ɵfac = function MarginLeftDirective_Factory(t) { return new (t || MarginLeftDirective)(); };
MarginLeftDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: MarginLeftDirective, selectors: [["", "margin-left", ""]], hostAttrs: [1, "margin-left"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarginLeftDirective, [{
        type: Directive,
        args: [{
                selector: "[margin-left]",
                host: { class: "margin-left" }
            }]
    }], null, null); })();

class PaddingDirective {
}
PaddingDirective.ɵfac = function PaddingDirective_Factory(t) { return new (t || PaddingDirective)(); };
PaddingDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingDirective, selectors: [["", "padding", ""]], hostAttrs: [1, "padding"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingDirective, [{
        type: Directive,
        args: [{
                selector: "[padding]",
                host: { class: "padding" }
            }]
    }], null, null); })();
class NoPaddingDirective {
}
NoPaddingDirective.ɵfac = function NoPaddingDirective_Factory(t) { return new (t || NoPaddingDirective)(); };
NoPaddingDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NoPaddingDirective, selectors: [["", "no-padding", ""]], hostAttrs: [1, "padding-none"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoPaddingDirective, [{
        type: Directive,
        args: [{
                selector: "[no-padding]",
                host: { class: "padding-none" }
            }]
    }], null, null); })();
class PaddingVerticalDirective {
}
PaddingVerticalDirective.ɵfac = function PaddingVerticalDirective_Factory(t) { return new (t || PaddingVerticalDirective)(); };
PaddingVerticalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingVerticalDirective, selectors: [["", "padding-vertical", ""]], hostAttrs: [1, "padding-vertical"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingVerticalDirective, [{
        type: Directive,
        args: [{
                selector: "[padding-vertical]",
                host: { class: "padding-vertical" }
            }]
    }], null, null); })();
class PaddingHorizontalDirective {
}
PaddingHorizontalDirective.ɵfac = function PaddingHorizontalDirective_Factory(t) { return new (t || PaddingHorizontalDirective)(); };
PaddingHorizontalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingHorizontalDirective, selectors: [["", "padding-horizontal", ""]], hostAttrs: [1, "padding-horizontal"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingHorizontalDirective, [{
        type: Directive,
        args: [{
                selector: "[padding-horizontal]",
                host: { class: "padding-horizontal" }
            }]
    }], null, null); })();
class PaddingTopDirective {
}
PaddingTopDirective.ɵfac = function PaddingTopDirective_Factory(t) { return new (t || PaddingTopDirective)(); };
PaddingTopDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingTopDirective, selectors: [["", "padding-top", ""]], hostAttrs: [1, "padding-top"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingTopDirective, [{
        type: Directive,
        args: [{
                selector: "[padding-top]",
                host: { class: "padding-top" }
            }]
    }], null, null); })();
class PaddingRightDirective {
}
PaddingRightDirective.ɵfac = function PaddingRightDirective_Factory(t) { return new (t || PaddingRightDirective)(); };
PaddingRightDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingRightDirective, selectors: [["", "padding-right", ""]], hostAttrs: [1, "padding-right"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingRightDirective, [{
        type: Directive,
        args: [{
                selector: "[padding-right]",
                host: { class: "padding-right" }
            }]
    }], null, null); })();
class PaddingBottomDirective {
}
PaddingBottomDirective.ɵfac = function PaddingBottomDirective_Factory(t) { return new (t || PaddingBottomDirective)(); };
PaddingBottomDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingBottomDirective, selectors: [["", "padding-bottom", ""]], hostAttrs: [1, "padding-bottom"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingBottomDirective, [{
        type: Directive,
        args: [{
                selector: "[padding-bottom]",
                host: { class: "padding-bottom" }
            }]
    }], null, null); })();
class PaddingLeftDirective {
}
PaddingLeftDirective.ɵfac = function PaddingLeftDirective_Factory(t) { return new (t || PaddingLeftDirective)(); };
PaddingLeftDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PaddingLeftDirective, selectors: [["", "padding-left", ""]], hostAttrs: [1, "padding-left"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaddingLeftDirective, [{
        type: Directive,
        args: [{
                selector: "[padding-left]",
                host: { class: "padding-left" }
            }]
    }], null, null); })();

class AtlasSpacingModule {
}
AtlasSpacingModule.ɵfac = function AtlasSpacingModule_Factory(t) { return new (t || AtlasSpacingModule)(); };
AtlasSpacingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AtlasSpacingModule });
AtlasSpacingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AtlasSpacingModule, { declarations: function () { return [MarginDirective, NoMarginDirective, MarginVerticalDirective, MarginHorizontalDirective, MarginTopDirective, MarginRightDirective, MarginLeftDirective, MarginBottomDirective, PaddingDirective, NoPaddingDirective, PaddingVerticalDirective, PaddingHorizontalDirective, PaddingTopDirective, PaddingRightDirective, PaddingBottomDirective, PaddingLeftDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [MarginDirective, NoMarginDirective, MarginVerticalDirective, MarginHorizontalDirective, MarginTopDirective, MarginRightDirective, MarginLeftDirective, MarginBottomDirective, PaddingDirective, NoPaddingDirective, PaddingVerticalDirective, PaddingHorizontalDirective, PaddingTopDirective, PaddingRightDirective, PaddingBottomDirective, PaddingLeftDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasSpacingModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MarginDirective,
                    NoMarginDirective,
                    MarginVerticalDirective,
                    MarginHorizontalDirective,
                    MarginTopDirective,
                    MarginRightDirective,
                    MarginLeftDirective,
                    MarginBottomDirective,
                    PaddingDirective,
                    NoPaddingDirective,
                    PaddingVerticalDirective,
                    PaddingHorizontalDirective,
                    PaddingTopDirective,
                    PaddingRightDirective,
                    PaddingBottomDirective,
                    PaddingLeftDirective
                ],
                imports: [CommonModule],
                exports: [
                    MarginDirective,
                    NoMarginDirective,
                    MarginVerticalDirective,
                    MarginHorizontalDirective,
                    MarginTopDirective,
                    MarginRightDirective,
                    MarginLeftDirective,
                    MarginBottomDirective,
                    PaddingDirective,
                    NoPaddingDirective,
                    PaddingVerticalDirective,
                    PaddingHorizontalDirective,
                    PaddingTopDirective,
                    PaddingRightDirective,
                    PaddingBottomDirective,
                    PaddingLeftDirective
                ]
            }]
    }], null, null); })();

class AtlasFontThinDirective {
}
AtlasFontThinDirective.ɵfac = function AtlasFontThinDirective_Factory(t) { return new (t || AtlasFontThinDirective)(); };
AtlasFontThinDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasFontThinDirective, selectors: [["", "atlas-light", ""]], hostAttrs: [1, "atl-text-light"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasFontThinDirective, [{
        type: Directive,
        args: [{
                selector: "[atlas-light]",
                host: { class: "atl-text-light" }
            }]
    }], null, null); })();
class AtlasFontRegularDirective {
}
AtlasFontRegularDirective.ɵfac = function AtlasFontRegularDirective_Factory(t) { return new (t || AtlasFontRegularDirective)(); };
AtlasFontRegularDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasFontRegularDirective, selectors: [["", "atlas-regular", ""]], hostAttrs: [1, "atl-text-regular"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasFontRegularDirective, [{
        type: Directive,
        args: [{
                selector: "[atlas-regular]",
                host: { class: "atl-text-regular" }
            }]
    }], null, null); })();
class AtlasFontSemiBoldDirective {
}
AtlasFontSemiBoldDirective.ɵfac = function AtlasFontSemiBoldDirective_Factory(t) { return new (t || AtlasFontSemiBoldDirective)(); };
AtlasFontSemiBoldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasFontSemiBoldDirective, selectors: [["", "atlas-semi-bold", ""]], hostAttrs: [1, "atl-text-semi-bold"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasFontSemiBoldDirective, [{
        type: Directive,
        args: [{
                selector: "[atlas-semi-bold]",
                host: { class: "atl-text-semi-bold" }
            }]
    }], null, null); })();
class AtlasFontBoldDirective {
}
AtlasFontBoldDirective.ɵfac = function AtlasFontBoldDirective_Factory(t) { return new (t || AtlasFontBoldDirective)(); };
AtlasFontBoldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasFontBoldDirective, selectors: [["", "atlas-bold", ""]], hostAttrs: [1, "atl-text-bold"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasFontBoldDirective, [{
        type: Directive,
        args: [{
                selector: "[atlas-bold]",
                host: { class: "atl-text-bold" }
            }]
    }], null, null); })();
class AtlasFontBolderDirective {
}
AtlasFontBolderDirective.ɵfac = function AtlasFontBolderDirective_Factory(t) { return new (t || AtlasFontBolderDirective)(); };
AtlasFontBolderDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasFontBolderDirective, selectors: [["", "atlas-extra-bold", ""]], hostAttrs: [1, "atl-text-extra-bold"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasFontBolderDirective, [{
        type: Directive,
        args: [{
                selector: "[atlas-extra-bold]",
                host: { class: "atl-text-extra-bold" }
            }]
    }], null, null); })();

class AtlasFontStyleModule {
}
AtlasFontStyleModule.ɵfac = function AtlasFontStyleModule_Factory(t) { return new (t || AtlasFontStyleModule)(); };
AtlasFontStyleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AtlasFontStyleModule });
AtlasFontStyleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AtlasFontStyleModule, { declarations: function () { return [AtlasFontThinDirective, AtlasFontRegularDirective, AtlasFontSemiBoldDirective, AtlasFontBoldDirective, AtlasFontBolderDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AtlasFontThinDirective, AtlasFontRegularDirective, AtlasFontSemiBoldDirective, AtlasFontBoldDirective, AtlasFontBolderDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasFontStyleModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AtlasFontThinDirective,
                    AtlasFontRegularDirective,
                    AtlasFontSemiBoldDirective,
                    AtlasFontBoldDirective,
                    AtlasFontBolderDirective
                ],
                imports: [CommonModule],
                exports: [
                    AtlasFontThinDirective,
                    AtlasFontRegularDirective,
                    AtlasFontSemiBoldDirective,
                    AtlasFontBoldDirective,
                    AtlasFontBolderDirective
                ]
            }]
    }], null, null); })();

class ReleaseFlagConfig {
}
const RELEASE_CONFIG = new InjectionToken('RELEASE_CONFIG');

class ReleaseFlagDirective {
    constructor(flagConfig, _viewContainer, _templateRef) {
        this.flagConfig = flagConfig;
        this._viewContainer = _viewContainer;
        this._templateRef = _templateRef;
        this._elseTemplateRef = null;
        this._elseViewRef = null;
    }
    /**
     * The release flag to evaluate for showing a template.
     */
    set atlasReleaseFlag(flag) {
        this._flagName = flag;
        this.updateViewContainer();
    }
    /**
     * A template to show if the release flag is disabled.
     */
    set atlasReleaseFlagElse(templateRef) {
        this.assertTemplate('atlasReleaseFlagElse', templateRef);
        this._elseTemplateRef = templateRef;
        this._elseViewRef = null;
        this.updateViewContainer();
    }
    updateViewContainer() {
        if (this.isEnabled(this._flagName)) {
            this._viewContainer.clear();
            this._viewContainer.createEmbeddedView(this._templateRef);
            this._elseViewRef = null;
        }
        else {
            if (!this._elseViewRef) {
                this._viewContainer.clear();
                if (this._elseTemplateRef) {
                    this._elseViewRef = this._viewContainer.createEmbeddedView(this._elseTemplateRef);
                }
            }
        }
    }
    isEnabled(flag) {
        return (this.flagConfig && this.flagConfig[flag]) ? this.flagConfig[flag] : false;
    }
    assertTemplate(property, templateRef) {
        const isTemplateRefOrNull = !!(!templateRef || templateRef.createEmbeddedView);
        if (!isTemplateRefOrNull) {
            throw new Error(`${property} must be a TemplateRef.`);
        }
    }
}
ReleaseFlagDirective.ɵfac = function ReleaseFlagDirective_Factory(t) { return new (t || ReleaseFlagDirective)(ɵngcc0.ɵɵdirectiveInject(RELEASE_CONFIG), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ReleaseFlagDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ReleaseFlagDirective, selectors: [["", "atlasReleaseFlag", ""]], inputs: { atlasReleaseFlag: "atlasReleaseFlag", atlasReleaseFlagElse: "atlasReleaseFlagElse" } });
ReleaseFlagDirective.ctorParameters = () => [
    { type: ReleaseFlagConfig, decorators: [{ type: Inject, args: [RELEASE_CONFIG,] }] },
    { type: ViewContainerRef },
    { type: TemplateRef }
];
ReleaseFlagDirective.propDecorators = {
    atlasReleaseFlag: [{ type: Input }],
    atlasReleaseFlagElse: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReleaseFlagDirective, [{
        type: Directive,
        args: [{
                selector: `[atlasReleaseFlag]`
            }]
    }], function () { return [{ type: ReleaseFlagConfig, decorators: [{
                type: Inject,
                args: [RELEASE_CONFIG]
            }] }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }]; }, { atlasReleaseFlag: [{
            type: Input
        }], atlasReleaseFlagElse: [{
            type: Input
        }] }); })();

class ReleaseFlagModule {
}
ReleaseFlagModule.ɵfac = function ReleaseFlagModule_Factory(t) { return new (t || ReleaseFlagModule)(); };
ReleaseFlagModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ReleaseFlagModule });
ReleaseFlagModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ReleaseFlagModule, { declarations: function () { return [ReleaseFlagDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ReleaseFlagDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReleaseFlagModule, [{
        type: NgModule,
        args: [{
                declarations: [ReleaseFlagDirective],
                imports: [
                    CommonModule
                ],
                exports: [
                    ReleaseFlagDirective
                ]
            }]
    }], null, null); })();

class AtlasDateMaskDirective {
    constructor(element) {
        this.element = element;
        this.mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // mm/dd/yyyy
        this.maskedInputController = maskInput({
            inputElement: this.element.nativeElement,
            mask: this.mask
        });
    }
    ngOnDestroy() {
        this.maskedInputController.destroy();
    }
}
AtlasDateMaskDirective.ɵfac = function AtlasDateMaskDirective_Factory(t) { return new (t || AtlasDateMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AtlasDateMaskDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AtlasDateMaskDirective, selectors: [["", "atlasDateMask", ""]] });
AtlasDateMaskDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasDateMaskDirective, [{
        type: Directive,
        args: [{
                selector: '[atlasDateMask]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
class AtlasDateAdapter extends NativeDateAdapter {
    format(date, displayFormat) {
        if (displayFormat === 'input') {
            let day = date.getDate().toString();
            day = +day < 10 ? '0' + day : day;
            let month = (date.getMonth() + 1).toString();
            month = +month < 10 ? '0' + month : month;
            let year = date.getFullYear();
            return `${month}/${day}/${year}`;
        }
        return date.toDateString();
    }
}
AtlasDateAdapter.ɵfac = function AtlasDateAdapter_Factory(t) { return ɵAtlasDateAdapter_BaseFactory(t || AtlasDateAdapter); };
AtlasDateAdapter.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AtlasDateAdapter, factory: AtlasDateAdapter.ɵfac });
const ɵAtlasDateAdapter_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AtlasDateAdapter);
const ATLAS_DATE_FORMATS = {
    parse: {
        dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
    },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'numeric' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric'
        },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    }
};

const ɵ0 = ATLAS_DATE_FORMATS;
class AtlasDateMaskModule {
}
AtlasDateMaskModule.ɵfac = function AtlasDateMaskModule_Factory(t) { return new (t || AtlasDateMaskModule)(); };
AtlasDateMaskModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AtlasDateMaskModule });
AtlasDateMaskModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ providers: [
        { provide: DateAdapter, useClass: AtlasDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: ɵ0 }
    ], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AtlasDateMaskModule, { declarations: function () { return [AtlasDateMaskDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AtlasDateMaskDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtlasDateMaskModule, [{
        type: NgModule,
        args: [{
                declarations: [AtlasDateMaskDirective],
                imports: [
                    CommonModule
                ],
                exports: [
                    AtlasDateMaskDirective
                ],
                providers: [
                    { provide: DateAdapter, useClass: AtlasDateAdapter },
                    { provide: MAT_DATE_FORMATS, useValue: ɵ0 }
                ]
            }]
    }], null, null); })();

class StyleManagerService {
    constructor() { }
    static getLinkElementForKey(key) {
        return StyleManagerService.getExistingLinkElementByKey(key) || StyleManagerService.createLinkElementWithKey(key);
    }
    static getExistingLinkElementByKey(key) {
        return document.head.querySelector(`link[rel="stylesheet"].${StyleManagerService.getClassNameForKey(key)}`);
    }
    static createLinkElementWithKey(key) {
        const linkEl = document.createElement("link");
        linkEl.setAttribute("rel", "stylesheet");
        linkEl.setAttribute("type", "text/css");
        linkEl.classList.add(StyleManagerService.getClassNameForKey(key));
        document.head.appendChild(linkEl);
        return linkEl;
    }
    static getClassNameForKey(key) {
        return `style-manager-${key}`;
    }
    /** * Set the stylesheet with the specified key. */
    setStyle(key, href) {
        StyleManagerService.getLinkElementForKey(key).setAttribute("href", href);
    }
    /** * Remove the stylesheet with the specified key. */
    removeStyle(key) {
        const existingLinkElement = StyleManagerService.getExistingLinkElementByKey(key);
        if (existingLinkElement) {
            document.head.removeChild(existingLinkElement);
        }
    }
}
StyleManagerService.ɵfac = function StyleManagerService_Factory(t) { return new (t || StyleManagerService)(); };
StyleManagerService.ɵprov = ɵɵdefineInjectable({ factory: function StyleManagerService_Factory() { return new StyleManagerService(); }, token: StyleManagerService, providedIn: "root" });
StyleManagerService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StyleManagerService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();

class BrowserSupport {
    constructor(browserConfig, snackBar) {
        this.browserConfig = browserConfig;
        this.snackBar = snackBar;
    }
    validateBrowser() {
        if (!this.isBrowserSupported()) {
            const ref = this.snackBar.open(this.browserConfig.unsupported.message, this.browserConfig.unsupported.action, this.browserConfig.unsupported.config);
            return ref;
        }
    }
}
class BrowserSupportConfig {
}
const BROWSER_SUPPORT_CONFIG = new InjectionToken('BROWSER_SUPPORT_CONFIG');

/*
 * Public API Surface of material
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionModule, AtlasButtonModule, AtlasDateMaskDirective, AtlasDateMaskModule, AtlasFontBoldDirective, AtlasFontBolderDirective, AtlasFontRegularDirective, AtlasFontSemiBoldDirective, AtlasFontStyleModule, AtlasFontThinDirective, AtlasLargeButtonDirective, AtlasLinkDirective, AtlasLinkModule, AtlasMediumButtonDirective, AtlasNavigationButtonDirective, AtlasSmallButtonDirective, AtlasSpacingModule, AtlasXSmallButtonDirective, AtlasXSmallLightButtonDirective, BROWSER_SUPPORT_CONFIG, BrowserSupport, BrowserSupportConfig, CarouselComponent, CarouselItemComponent, CarouselModule, MarginBottomDirective, MarginDirective, MarginHorizontalDirective, MarginLeftDirective, MarginRightDirective, MarginTopDirective, MarginVerticalDirective, NoMarginDirective, NoPaddingDirective, PaddingBottomDirective, PaddingDirective, PaddingHorizontalDirective, PaddingLeftDirective, PaddingRightDirective, PaddingTopDirective, PaddingVerticalDirective, RELEASE_CONFIG, ReleaseFlagConfig, ReleaseFlagDirective, ReleaseFlagModule, SearchBarComponent, SearchBarModule, SideNavComponent, SideNavModule, SliderComponent, SliderModule, StickyHeaderComponent, StickyHeaderModule, StyleManagerService };

//# sourceMappingURL=atlas-material.js.map